export default "__VITE_ASSET__CMlgaSUk__"